import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './block-image.scss';

export class BlockImage extends PureComponent {
  render() {
    const { title, src, alt } = this.props.content;

    return (
      <div className="block-image">
        {(!!title) &&
          <h2 dangerouslySetInnerHTML={{ __html: title }} />
        }

        <img src={src} alt={alt} />
      </div>
    );
  }
}

BlockImage.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string
  })
};

export default BlockImage;



// WEBPACK FOOTER //
// ./src/components/widgets/Typography/BlockImage.js